import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { useEffect, useRef } from 'react';
import { Text } from '@/components/ui/Typography/Body/Text';
import { Head } from '@/components/ui/Typography/Heading/Head';
import { tailwindConfig } from '@/style/config';
const colors = {
    orange: {
        head: 'text-secondary',
        pie: tailwindConfig.theme.colors.orange['100'],
        text: 'secondary',
    },
};
/**
 * 比率表示のコンポーネント
 * @param props
 * @constructor
 */
export const PieChart = (props) => {
    const { className, color = 'orange', percent, title, unit } = props;
    const ref = useRef(null);
    useEffect(() => {
        const canvas = ref.current;
        if (canvas) {
            // 親要素の幅を取得
            const clientWidth = canvas.clientWidth.toString();
            canvas.setAttribute('width', clientWidth);
            canvas.setAttribute('height', clientWidth);
            const context = canvas.getContext('2d');
            if (context) {
                // canvasを描画する
                const { height, width } = canvas;
                const setWidth = width / 2;
                const setHeight = height / 2;
                const angle = 360 * (percent / 100);
                context.clearRect(0, 0, width, height);
                context.beginPath();
                context.arc(setWidth, setHeight, setWidth, ((0 - 90) * Math.PI) / 180, ((angle - 90) * Math.PI) / 180, false);
                context.lineTo(setWidth, setHeight);
                context.fillStyle = colors[color].pie;
                context.fill();
            }
        }
    }, [color, percent, ref]);
    return (_jsx("div", Object.assign({ className: clsx(className, 'w-[54px] h-[54px]') }, { children: _jsxs("div", Object.assign({ className: 'relative w-full h-full' }, { children: [_jsx("canvas", { className: 'w-full h-full', ref: ref }), _jsxs("div", Object.assign({ className: clsx('h-[44px] w-[44px]', 'absolute top-[5px] right-[5px] top-[5px] bottom-[5px]', 'flex items-center flex-direction-column', 'rounded-full', 'bg-white') }, { children: [_jsx(Text, Object.assign({ color: colors[color].text, isBold: true, size: 'xs' }, { children: title })), _jsxs("div", Object.assign({ className: 'flex justify-center items-baseline' }, { children: [_jsx(Head, Object.assign({ className: clsx('leading-none', colors[color].head), color: 'none', size: 'md' }, { children: percent })), _jsx(Text, Object.assign({ color: colors[color].text, isBold: true, size: 'xs' }, { children: unit }))] }))] }))] })) })));
};
